module.exports = __webpack_public_path__ + "img/PY.a77c8033.svg";